import { useMemo } from 'react';
import { ExtensionConfig } from 'components/organisms/document-editor/types';
import { useGetDefaultFormattingCommands } from '../document-editor/extensions/command-picker/commands-list/formatting-commands';

export const useEditorExtensionsConfigForCompanyPage =
  (): Partial<ExtensionConfig> => {
    const formattingCommands = useGetDefaultFormattingCommands();

    return useMemo(() => {
      return {
        commandsPickerConfig: {
          enabled: true,
          items: formattingCommands,
        },
      };
    }, [formattingCommands]);
  };
